import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { primaryBG } from '../../../../theme/colors';
import breakpoints from '../../../../theme/material/breakpoints';

const StyledContainer = styled('div')({
  textAlign: 'center',
  padding: '30px 0',
  display: 'block',

  [breakpoints.down(620.05)]: {
    display: 'none',
    backgroundColor: primaryBG,
    borderRadius: 8,
    marginTop: -65,
    position: 'relative',
  },
});

interface IBulkUploadActionButtonContainerProps {
  children: ReactNode;
  customStyle?: React.CSSProperties;
}

const GalleryUploadDesktopActionButtonContainer: React.FC<IBulkUploadActionButtonContainerProps> = (
  props: IBulkUploadActionButtonContainerProps
) => {
  const { children, customStyle } = props;

  return <StyledContainer style={{ ...customStyle }}>{children}</StyledContainer>;
};

export default GalleryUploadDesktopActionButtonContainer;
